import { ExternalHyperlink, Paragraph, TextRun } from 'docx';

// Constants
import {
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  LINE_SPACING,
  SPACINGS,
} from '../constants';

/** Run config for richTextParser matching AgilityIO Proxima Nova 11pt body style */
export const AGILITYIO_RUN_CONFIG = {
  fontFamily: FONT_FAMILY,
  fontSize: FONT_SIZE.base,
  color: COLORS.foreground,
} as const;

/** Object form of TextRun constructor options */
type TextRunOptions = Extract<ConstructorParameters<typeof TextRun>[0], object>;

/** Creates a body-sized TextRun with optional overrides */
export const bodyRun = (text: string, options?: Partial<TextRunOptions>) =>
  new TextRun({
    text,
    font: FONT_FAMILY,
    size: FONT_SIZE.base,
    color: COLORS.foreground,
    ...options,
  });

/** Creates a section heading paragraph */
export const sectionHeading = (
  title: string,
  spacing: { before?: number; after?: number } = {},
): Paragraph =>
  new Paragraph({
    spacing: { after: SPACINGS.sectionHeadingGap, ...spacing },
    children: [
      new TextRun({
        text: title,
        font: FONT_FAMILY,
        size: FONT_SIZE.lg,
        color: COLORS.primary,
        bold: true,
      }),
    ],
  });

/** Creates a bullet paragraph with a bullet prefix */
export const bulletParagraph = (
  runs: (TextRun | ExternalHyperlink)[],
  spacing?: { before?: number; after?: number },
): Paragraph =>
  new Paragraph({
    spacing: { line: LINE_SPACING, ...spacing },
    indent: { left: SPACINGS.listIndent },
    children: [bodyRun('•  '), ...runs],
  });

/** Creates an empty paragraph used as section bottom spacing */
export const sectionSpacer = () =>
  new Paragraph({
    spacing: { after: SPACINGS.sectionGap },
  });
